import type { FC } from 'react'
import type { ICmsFeatureItem } from '@/pages/tad.ai/_components/FeatureCms/_types'

import LazyImage from '@/components/LazyImage'
import { H2 } from '@/pages/tad.ai/_components/H2'
import { PrimaryButton } from '@/pages/tad.ai/_components/PrimaryButton'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'


import { cls } from 'tagged-classnames-free';
export interface IFeaturesProps {
  features?: ICmsFeatureItem[] | null
  reverse?: boolean
  className?: string
}

export const Features: FC<IFeaturesProps> = (props) => {
  const { features, reverse, className } = props
  if (!features?.length) {
    return null
  }

  return (
    <div className={cls`flex flex-col gap-9 ${className}`}>
      {features.map((item, index) => {
        const isLeft =
          item.isLeft ?? (reverse ? index % 2 === 0 : index % 2 !== 0)
        const imgSrc = item.img?.src

        return (
          <div
            key={item.title}
            className={cls`flex flex-col items-center gap-8 lg:gap-[140px] ${isLeft ? 'md:flex-row-reverse' : 'md:flex-row'}`}
          >
            <div className='flex-1'>
              <H2 className='md:text-start md:text-4xl'>{item.title}</H2>
              <RichTextElement
                as='p'
                html={item.desc}
                className='text-f-other-10 [&_a]:text-f-primary pt-3 text-sm md:text-base '
              />
              {item.btnText && item.btnHref && (
                <PrimaryButton
                  href={item.btnHref}
                  className='mt-3 text-sm md:mt-6 md:text-base'
                >
                  {item.btnText}
                </PrimaryButton>
              )}
            </div>
            {imgSrc && (
              <LazyImage
                width={item.img?.width ?? 480}
                height={item.img?.height ?? 320}
                src={imgSrc}
                alt={item.title}
                className='rounded-lg'
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
